export const CLUSTER_LAYER_SIZE = 20

export const POINT_LAYER_SIZE = [1, 2]

export const LINE_LAYER_SIZE = 7
export const SELECTED_LINE_LAYER_SIZE = 14
export const CIRCLE_LAYER_SIZE = 7
export const SELECTED_CIRCLE_LAYER_SIZE = 10
export const LINE_LAYER_SIZE_OFFSET = 4

export const MIN_LINE_OFFSET = 5
export const MAX_LINE_OFFSET = 15

export const INTERPOLATION_ZOOM_MIN = 10
export const INTERPOLATION_ZOOM_MAX = 18

export const REFERENTIAL_SOURCE = "referential"
export const REFERENTIAL_LAYER = "referentialLayer"
export const REFERENTIAL_LAYER_CLICKABLE = "referentialLayerClickable"
export const SELECTABLE_REFERENTIAL_LAYER = "selectableReferentialLayer"
export const NOTATION_SOURCE = "notation"
export const NOTATION_LAYER = "notationLayer"
export const NOTATION_LAYER_CLICK = "notationLayerClick"
export const DAMAGES_SOURCE = "damages"
export const DAMAGES_LAYER_POINT = "damagesLayer-point"
export const DAMAGES_LAYER_LINE = "damagesLayer-line"
export const CATALOG_ITEMS_LAYER = "catalogItemsLayer"
export const CATALOG_ITEMS_SOURCE = "catalogItemsSource"
export const CATALOG_ITEMS_LAYER_CLUSTER = "catalogItemsCluster"
export const CATALOG_ITEMS_LAYER_CLUSTER_COUNT = "catalogItemsClusterCount"
export const CUT_ROADWORKS_LAYER_LINES = "cutRoadworks-lines"
export const CUT_ROADWORKS_LAYER_POINT = "cutRoadworks-point"
export const CUT_ROADWORKS_SOURCE = "cutRoadworksSource"
export const DOCUMENT_ATTACHED_ITEM_LAYER = "documentAtachedItemLayer"
export const DOCUMENT_ITEMS_LAYER = "catalogItemsLayer"
export const DOCUMENT_ITEMS_SOURCE = "catalogItemsSource"
export const DOCUMENTS_LAYER = "documentsLayer"
export const CAMPAIGNS_LAYER_CLUSTER = "campaignsLayerCluster"
export const CAMPAIGNS_LAYER_CLUSTER_COUNT = "campaignsLayerClusterCount"
export const CAMPAIGNS_LAYER = "campaignsLayer"
export const CAMPAIGNS_LAYER_HOVERED = "campaignsLayerHovered"
export const CAMPAIGNS_SOURCE = "campaignsSource"
export const DOCUMENTS_SOURCE = "documentsSource"
export const IMAGE_COLLECTION_SOURCE = "imageCollection"
export const IMAGE_COLLECTION_BORDER_LAYER = "imageCollectionBorder"
export const IMAGE_COLLECTION_LAYER = "imageCollectionLayer"
export const IMAGE_SELECTED_SOURCE = "imageSelectedSource"
export const IMAGE_SELECTED_BORDER_LAYER = "imageSelectedBorder"
export const IMAGE_SELECTED_LAYER = "imageSelectedLayer"
export const ROADWORK_CLICKABLE_LAYER = "roadworkLayerClickable"
export const ROADWORK_LAYER = "roadworkLayer"
export const ROADWORK_PAINTING_LAYER = "roadworkPaintingLayer"
export const ROADWORK_SOURCE = "roadworkSource"
export const ROADWORK_SECTION_LAYER = "roadworkSectionLayer"
export const ROADWORK_SECTION_SOURCE = "roadworkSectionSource"
export const RISK_ZONES_LAYER = "riskZonesLayer"
export const RISK_ZONES_SOURCE = "riskZonesSource"
export const SPEEDINGS_LAYER = "speedingsLayer"
export const SPEEDINGS_SOURCE = "speedingsSource"
export const ROAD_SPEEDINGS_LAYER = "roadSpeedingsLayer"
export const ROAD_SPEEDINGS_SOURCE = "roadSpeedingsSource"
export const ROAD_TRAFFIC_LAYER = "roadSpeedingsLayer"
export const ROAD_TRAFFIC_SOURCE = "roadSpeedingsSource"
export const TRAFFIC_SOURCE = "trafficSource"
export const TRAFFIC_LAYER = "trafficLayer"
export const ROADSIDE_SOURCE = "roadsideSource"
export const ROADSIDE_LAYER = "roadsideLayer"
export const ROAD_ROADSIDE_LAYER = "roadRoadsideLayer"
export const ROAD_ROADSIDE_SOURCE = "roadRoadsideSource"
export const USER_LOCATION_LAYER = "userLocationLayer"
export const USER_LOCATION_ACCURACY_LAYER = "userLocationAccuracyLayer"
export const USER_LOCATION_SOURCE = "userLocationSource"

export const layersZindexes = {
    [USER_LOCATION_LAYER]: -10,
    [USER_LOCATION_ACCURACY_LAYER]: -9,
    [IMAGE_SELECTED_LAYER]: -6,
    [IMAGE_SELECTED_BORDER_LAYER]: -5,
    [IMAGE_COLLECTION_LAYER]: -4,
    [IMAGE_COLLECTION_BORDER_LAYER]: -3,
    [CAMPAIGNS_LAYER_HOVERED]: -3,
    [CATALOG_ITEMS_LAYER_CLUSTER_COUNT]: -2,
    [CAMPAIGNS_LAYER_CLUSTER_COUNT]: -2,
    [CATALOG_ITEMS_LAYER]: -2,
    [RISK_ZONES_LAYER]: -1,
    [CATALOG_ITEMS_LAYER_CLUSTER]: -1,
    [CAMPAIGNS_LAYER_CLUSTER]: -1,
    [CAMPAIGNS_LAYER]: -1,
    [CATALOG_ITEMS_LAYER]: -1,
    "road-number": 0,
    "road-number-shield": 0,
    "road-label": 0,
    "road-label-simple": 0,
    [ROADWORK_CLICKABLE_LAYER]: 11,
    [CAMPAIGNS_LAYER]: 1,
    [DOCUMENT_ITEMS_LAYER]: 1,
    [DOCUMENTS_LAYER]: 1,
    [DOCUMENT_ATTACHED_ITEM_LAYER]: 2,
    [REFERENTIAL_LAYER_CLICKABLE]: 12,
    [SELECTABLE_REFERENTIAL_LAYER]: 12,
    [CUT_ROADWORKS_LAYER_LINES]: 20,
    [CUT_ROADWORKS_LAYER_POINT]: 20,
    [ROADWORK_PAINTING_LAYER]: 30,
    [DAMAGES_LAYER_POINT]: 30,
    [DAMAGES_LAYER_LINE]: 31,
    [ROAD_SPEEDINGS_LAYER]: 49,
    [ROAD_TRAFFIC_LAYER]: 49,
    [ROAD_ROADSIDE_LAYER]: 49,
    [ROADWORK_SECTION_LAYER]: 49,
    [NOTATION_LAYER]: 50,
    [ROADWORK_LAYER]: 50,
    [SPEEDINGS_LAYER]: 50,
    [TRAFFIC_LAYER]: 50,
    [ROADSIDE_LAYER]: 50,
    [NOTATION_LAYER_CLICK]: 51,
    [REFERENTIAL_LAYER]: 100,
}
